<div class="display-utils-col display-utils-gt-sm-row display-utils-center" *ngIf="this.showHero || this.showErrorHero">
    <div class="pme-col display-utils-gt-sm-flex-50">
        <pme-hero type="{{this.heroData.type}}" title="{{this.heroData.title}}"
            showButton="{{this.heroData.showButton}}" buttonName="{{this.heroData.buttonName}}"
            redirectURL="{{this.heroData.redirectURL}}">
            <p *ngFor="let content of this.heroData.contents" [innerHTML]="content"></p>
        </pme-hero>
    </div>
</div>

<main  class="main-container">
    <div class="pme-change-plan pme-container" *ngIf="this.currentPlan && this.othersPlans.length && this.classificationIdentifier !== 'plano-mensal'">
        
        <div class="shop-window">

            <div class="title">
                <h3>Alteração de Plano</h3>
            </div>
 
            <div class="display-utils-hide-gt-md">
                <p class="subtitle less-padding">
                    Plano atual: <span style="font-weight: bold;">{{currentPlan.planFullName}}</span> (validade do plano atual até
                    {{this.currentPlan.expirationDate}})
                </p>
                

                <swiper-container slides-per-view="auto" free-mode="true" (slidechange)="onSwipe()" class="products">
                    <swiper-slide>
                        <pme-product-change [productData]="currentPlan"></pme-product-change>
                    </swiper-slide>
                    <swiper-slide *ngFor="let product of othersPlans">
                        <pme-product-change [productData]="product" [returnUrl]="returnUrl" [redirectUrl]="redirectUrl"></pme-product-change>
                    </swiper-slide>
                </swiper-container>
            </div>


            <div class="display-utils-only-gt-md">
                <p class="subtitle less-padding">
                    Plano atual: <span style="font-weight: bold;">{{currentPlan.planFullName }}</span> (validade do plano atual até
                    {{this.currentPlan.expirationDate}})
                </p>

                <div class="list">
                    <pme-product-change [productData]="this.currentPlan"></pme-product-change>
                    <ng-container *ngFor="let product of othersPlans">
                        <pme-product-change [productData]="product" [redirectUrl]="redirectUrl"></pme-product-change>
                    </ng-container>
                </div>
            </div>
        </div>

        
       
            <p class="cancelation-info">
                {{currentPlan.footerText}}
            </p>

            
        <div class="payment-methods">
            <p>FORMAS DE PAGAMENTO</p>
            <div class="payment-brands">
                <ng-container *ngFor="let image of paymentMethodsImages">
                    <img src="/assets/images/payment-methods/{{image}}">
                </ng-container>
            </div>
        </div>
    </div>


    <!-- Inicio plano-mensal Upgrade -->
        <!-- Títulos -->
        <div *ngIf="this.currentPlan && this.othersPlans.length && this.classificationIdentifier === 'plano-mensal'">
            <div class="pme-container-assinatura">
              <div class="title-container-assinatura">
                <div class="left-title-assinatura">
                  <p class="main-left-title-assinatura">Escolha um plano para</p>
                  <p class="sub-left-title-assinatura">consultar ou cobrar clientes</p>
                </div>
        
                <div class="right-title-assinatura">
                  <p class="main-right-title-assinatura">
                    Consulta de CPF/CNPJ e Cobrança de Dívidas
                  </p>
                  <p class="sub-right-title-assinatura">
                    Quanto mais créditos você compra, mais descontos você ganha!
                  </p>
                </div>
              </div>
              <div class="divider-assinatura">
                <mat-divider inset></mat-divider>
              </div>
            </div>
            
            <p class="title-packages-block-assinatura">
              Escolha seu plano:
            </p>
            <div class="container-consulta-products-assinatura sticky-element-assinatura">
              <p class="title-packages-assinatura" style="width:150px;">Escolha seu plano:</p>
              <div class="products-container-assinatura">
                <div class="product-unit-assinatura" *ngFor="let plan of filteredUpgradeProducts; let i = index"
                  >
                  <pme-product style="overflow: hidden;" 
                  [context]="'UPGRADE_WINDOW'"
                        [someoneHasDiscountFloatBadge]="this.someoneHasDiscountFloatBadge" 
                        [productData]="plan"
                        [type]="'subscription'" [periodicity]="plan.product.periodicity" 
                        [currentProductData] = "this.filteredUpgradeCurrentProduct"
                        [redirectUrl]="redirectUrl"
                        [returnUrl]="returnUrl"
                        [isUpgradeWindow]="true">
                    </pme-product>
        
                  <!-- <div class="float-discount-badge-assinatura" *ngIf="plan !== this.filteredUpgradeCurrentProduct">
                    <div class="discount-badge-assinatura" *ngIf="
                        plan.appliedDiscounts &&
                        plan.appliedDiscounts.length &&
                        (plan.discountsType === 'EXTRA_BALANCE_ONLY' ||
                          plan.discountsType === 'NON_EXTRA_BALANCE_ONLY')
                      ">
                      <div class="discount-container-assinatura">
                        <p>Pague R$ {{ formatCurrency(plan.totalValue) }}</p>
                        <p>Receba R$ {{ formatCurrency(plan.discountsSum) }}!</p>
                      </div>
                    </div>
                  </div> -->
                  <!-- <div class="one-click-balloon-assinatura">
                    <div class="balloon-container-assinatura">
                      <pme-one-click-purchase></pme-one-click-purchase>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>

          <!-- Tabela maior -->

          <div *ngIf="this.classificationIdentifier === 'plano-mensal'" class="table-container-assinatura BB display-utils-only-gt-md">
    <div class="table-title-container-assinatura">
      <p class="table-title-assinatura">Tabela de <strong>preços</strong></p>
      <p class="table-description-assinatura">
        Consulte a tabela abaixo para entender o valor de cada consulta e quantas soluções você poderá utilizar.
      </p>
    </div>

    <div class="tabela-assinatura" *ngIf="filteredUpgradeProducts && filteredUpgradeProducts[0]">
      <div class="solutions-assinatura">
        <div class="table-header-assinatura"></div>
        <div>
          <div class="table-content-assinatura package-name-assinatura"
            *ngFor="let feature of filteredUpgradeProducts[packageIndex].featureList">
            <p>{{ feature.name }}</p>
          </div>
        </div>
      </div>

      <div class="price-table-assinatura" *ngIf="filteredUpgradeProducts">
        <div *ngFor="let subPackage of filteredUpgradeProducts; let i = index" class="price-table-column-assinatura">
          <div class="column">
            <div class="table-header-assinatura buy-button-assinatura">
              <div>
                <div class="discount-assinatura" >
                  <!-- <span class="discount-mark-assinatura" *ngIf="subPackage !== filteredUpgradeCurrentProduct">Plano R$ {{ formatCurrency(subPackage.baseValue) }}</span> -->
                  <div>
                    <p>Plano R$</p>
                    <!-- <b>
                      {{ subPackage === filteredUpgradeCurrentProduct ? formatCurrency(subPackage.baseValue) : formatCurrency(subPackage.totalValue) }}
                    </b> -->
                    <!-- <b>
                      {{ subPackage === filteredUpgradeCurrentProduct ? formatCurrency(subPackage.baseValue) : formatCurrency(subPackage.totalValue) }}
                    </b> -->
                    <b>
                      {{ formatCurrency(subPackage.baseValue)}}
                    </b>
                  </div>
                </div>
                <!-- <ng-template #baseValue *ngIf="subPackage !== filteredUpgradeCurrentProduct">
                  <div>
                    <p>Plano R$ {{ formatCurrency(subPackage.baseValue) }}</p>
                  </div>
                </ng-template> -->
              </div>
            </div>
            <div class="table-content-assinatura {{ subPackage === filteredUpgradeCurrentProduct ? 'actual-plan-table' : '' }}"
     *ngFor="let value of getValuesBasedOnFeatureList(filteredUpgradeProducts[packageIndex].featureList, subPackage)">
  <p>
    {{ value ? value + "/un" : "--" }}
  </p>
</div>

          </div>
        </div>
      </div>
    </div>

    <div class="divider divider-payment-assinatura-top-payment">
      <mat-divider inset></mat-divider>
    </div>
    <div class="pme-container pme-my-plan-payment-methods pme-payment-methods-assinatura">
      <p>Formas de pagamento</p>
      <div class="payment-brands">
        <ng-container *ngFor="let image of paymentMethodsImages">
          <img src="/assets/images/payment-methods/{{ image }}" />
        </ng-container>
      </div>
    </div>
    <div class="divider divider-bottom-payment-assinatura">
      <mat-divider inset></mat-divider>
    </div>
  </div>
  <!-- tabela maior fim -->



  <!-- tabela menor -->
  <div class="table-container-assinatura AA display-utils-hide-gt-md" *ngIf="this.classificationIdentifier === 'plano-mensal'">
  <div class="table-title-container-assinatura">
    <p class="table-title-assinatura">Tabela de <strong>preços</strong></p>
    <p class="table-description-assinatura">
      Consulte a tabela abaixo para entender o valor de cada consulta e quantas soluções você poderá utilizar.
    </p>
  </div>
  <div class="tabela-assinatura no-margin" *ngIf="filteredUpgradeProducts && filteredUpgradeProducts[0]" [style]="{ 'padding-top': '16px' }">
    <div class="solutions-swiper">
      <div class="solutions-assinatura">
        <div class="table-header-assinatura" style="height: 44px;"></div>
        <div>
          <div class="table-content-assinatura package-name-assinatura" *ngFor="
              let feature of filteredUpgradeProducts[packageIndex].featureList
            ">
            <p>{{ feature.name }}</p>
          </div>
        </div>
      </div>
      <swiper-container *ngIf="filteredUpgradeProducts" slides-per-view="auto" free-mode="true" (slidechange)="onSwipe()"
        class="price-table-assinatura swiper-slide-table">
        <swiper-slide *ngFor="let subPackage of filteredUpgradeProducts; let i = index">
          <div class="price-table-column-assinatura">
          <div class="column">
            <div class="table-header-assinatura buy-button-assinatura">
              <div>
                <div class="discount-assinatura" >
                  <!-- <span class="discount-mark-assinatura" *ngIf="subPackage !== filteredUpgradeCurrentProduct">Plano R$ {{ formatCurrency(subPackage.baseValue) }}</span> -->
                  <div>
                    <p>Plano R$</p>
                    <!-- <b>
                      {{ subPackage === filteredUpgradeCurrentProduct ? formatCurrency(subPackage.baseValue) : formatCurrency(subPackage.totalValue) }}
                    </b> -->
                    <!-- <b>
                      {{ subPackage === filteredUpgradeCurrentProduct ? formatCurrency(subPackage.baseValue) : formatCurrency(subPackage.totalValue) }}
                    </b> -->
                    <b>
                      {{ formatCurrency(subPackage.baseValue)}}
                    </b>
                  </div>
                </div>
                <!-- <ng-template #baseValue *ngIf="subPackage !== filteredUpgradeCurrentProduct">
                  <div>
                    <p>Plano R$ {{ formatCurrency(subPackage.baseValue) }}</p>
                  </div>
                </ng-template> -->
              </div>
            </div>
            <div class="table-content-assinatura {{ subPackage === filteredUpgradeCurrentProduct ? 'actual-plan-table' : '' }}"
     *ngFor="let value of getValuesBasedOnFeatureList(filteredUpgradeProducts[packageIndex].featureList, subPackage)">
  <p>
    {{ value ? value + "/un" : "--" }}
  </p>
</div>
          </div>
          </div>
        </swiper-slide>
      </swiper-container>
    </div>
  </div>
  <div class="divider divider-payment-assinatura">
    <mat-divider inset></mat-divider>
  </div>

  <div class="pme-container pme-my-plan-payment-methods pme-payment-methods-assinatura">
    <p>Formas de pagamento</p>
    <div class="payment-brands">
      <ng-container *ngFor="let image of paymentMethodsImages">
        <img src="/assets/images/payment-methods/{{ image }}" />
      </ng-container>
    </div>
  </div>
  <div class="divider divider-bottom-payment-assinatura">
    <mat-divider inset></mat-divider>
  </div>
</div>
  <!-- tabela menor fim -->
    <!-- Fim plano-mensal Upgrade -->

</main> 